/*
 * "Check my store" box on the Datify landing pages. Sends the store address to the
 * Datify app, polls until the scan finishes and shows the grade with the gaps found.
 * Every form with [data-dfy-check] on the page works the same way.
 */
(function () {
  if (window.__dfyStoreCheck) return;
  window.__dfyStoreCheck = true;

  var POLL_MS = 2000;
  var MAX_WAIT_MS = 3 * 60 * 1000;
  var FIELD_LABELS = {
    name: 'Name',
    description: 'Description',
    image: 'Image',
    price: 'Price',
    currency: 'Currency',
    availability: 'Availability',
    brand: 'Brand',
    sku: 'SKU',
    gtin: 'GTIN (barcode)',
  };
  var MESSAGES = {
    invalid_store: 'Enter your store address, for example yourstore.com or yourstore.myshopify.com.',
    rate_limited: 'You have run a lot of checks in the last hour. Please try again a little later.',
    busy: 'The checker is busy right now. Please try again in a minute.',
    network: 'We could not reach the checker. Please try again in a minute.',
    timeout: 'The check took too long, so we stopped waiting. Please try again in a few minutes.',
  };
  var OUTCOMES = {
    password_locked: {
      title: 'Your store is password protected',
      text: 'AI shopping agents cannot see a store behind a password either. Install Datify to check your catalog from inside your Shopify admin.',
    },
    not_shopify: {
      title: 'That site does not look like a Shopify store',
      text: 'Datify works with Shopify stores. If this is a Shopify store, try its myshopify.com address.',
    },
    unreachable: {
      title: 'We could not reach that address',
      text: 'Check the spelling, or try your store’s myshopify.com address.',
    },
    blocked: {
      title: 'Your store stopped our checker with a bot challenge',
      text: 'AI shopping agents can hit the same wall. Install Datify to check your catalog from inside your Shopify admin.',
    },
    robots_unavailable: {
      title: 'We could not read your robots.txt',
      text: 'When robots.txt does not answer, polite crawlers (ours included) treat the whole store as off limits. AI agents that follow the rules will too.',
    },
    crawl_delay_too_long: {
      title: 'Your robots.txt asks crawlers to wait more than 10 seconds between pages',
      text: 'We respect that, so we stopped. Install Datify to check your catalog from inside your Shopify admin.',
    },
    no_products: {
      title: 'We could not find any product pages',
      text: 'Your sitemap and home page did not link to products we could read. Install Datify to check your catalog from inside your Shopify admin.',
    },
    no_readable_product_pages: {
      title: 'We could not read your product pages',
      text: 'Install Datify to check your catalog from inside your Shopify admin.',
    },
    rate_limited: {
      title: 'Your store asked our checker to slow down',
      text: 'It answered \u201ctoo many requests\u201d. Please try again in a few minutes.',
    },
    error: {
      title: 'Something went wrong while checking your store',
      text: 'Please try again in a few minutes.',
    },
  };

  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    Object.keys(attrs || {}).forEach(function (key) {
      if (key === 'text') node.textContent = attrs[key];
      else node.setAttribute(key, attrs[key]);
    });
    (children || []).forEach(function (child) {
      if (child) node.appendChild(child);
    });
    return node;
  }

  function utm() {
    var params = new URLSearchParams(window.location.search);
    return {
      source: params.get('utm_source') || undefined,
      medium: params.get('utm_medium') || undefined,
      campaign: params.get('utm_campaign') || undefined,
    };
  }

  function track(name, detail) {
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, detail);
    } catch (e) {}
    try {
      if (window.clarity) window.clarity('event', name);
    } catch (e) {}
  }

  // Pages that leave the install link out (the research page) show no install button.
  function installLink(form, label) {
    if (!form.dataset.installUrl) return null;
    var a = el('a', { class: 'dfy-btn dfy-btn--primary', href: form.dataset.installUrl, text: label });
    a.addEventListener('click', function () {
      track('datify_install_click', { from: 'store_check_result' });
    });
    return a;
  }

  function band(grade) {
    if (grade >= 89) return 'good';
    if (grade < 60) return 'poor';
    return 'ok';
  }

  function renderProgress(target, host) {
    target.replaceChildren(
      el('div', { class: 'dfy-result', role: 'status' }, [
        el('div', { class: 'dfy-progress' }, [
          el('div', { class: 'dfy-spinner', 'aria-hidden': 'true' }),
          el('div', {}, [
            el('h3', { text: 'Reading ' + host + ' the way an AI shopping agent does' }),
            el('p', {
              class: 'dfy-note',
              text: 'We open your robots.txt, your sitemap and up to five product pages, one second apart, so this takes 20 to 60 seconds.',
            }),
          ]),
        ]),
      ])
    );
  }

  function renderOutcome(target, form, result) {
    var outcome = result.outcome === 'home_http_429' ? 'rate_limited' : result.outcome;
    var info = OUTCOMES[outcome] || (/^home_http_/.test(outcome || '') ? OUTCOMES.unreachable : OUTCOMES.error);
    target.replaceChildren(
      el('div', { class: 'dfy-result', role: 'status' }, [
        el('h2', { text: info.title }),
        el('p', { class: 'dfy-sub', style: 'margin:10px 0 20px', text: info.text }),
        form.dataset.installUrl ? el('div', { class: 'dfy-result__cta' }, [installLink(form, 'Install Datify free on Shopify')]) : null,
      ])
    );
  }

  function money(price) {
    if (!price || typeof price.amount !== 'number') return null;
    try {
      var fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: price.currency || 'USD' });
      return fmt.format(price.amount / Math.pow(10, fmt.resolvedOptions().maximumFractionDigits));
    } catch (e) {
      return null;
    }
  }

  function plural(n, word) {
    return n + ' ' + word + (n === 1 ? '' : 's');
  }

  // What the store's UCP catalog (Shopify's catalog for AI agents) returned for one product.
  function renderUcp(ucp, storeHost, gtinOnPage) {
    if (!ucp || ucp.outcome !== 'ok' || !ucp.product) return null;
    var p = ucp.product;
    var store = p.store || {};
    var rows = [];
    function row(label, value, ok, note) {
      rows.push(
        el('div', { class: 'dfy-ucp__row', 'data-ok': String(ok) }, [
          el('dt', { text: label }),
          el('dd', {}, [el('span', { text: value }), note ? el('small', { text: note }) : null]),
        ])
      );
    }
    row('Title', p.title || 'None', Boolean(p.title));
    row(
      'Category',
      p.category ? p.category.fullName || p.category.name || p.category.id : 'Uncategorized',
      Boolean(p.category),
      p.category ? null : 'Agents cannot tell what kind of product this is.'
    );
    row('Price', money(p.price) || 'None', Boolean(p.price));
    row(
      'Description',
      p.description ? p.description + (p.descriptionChars > p.description.length ? '…' : '') : 'None',
      Boolean(p.description)
    );
    // Shopify gives single-variant products a placeholder option, Title / Default Title.
    var options = (p.options || []).filter(function (o) {
      return !(o.name === 'Title' && o.values <= 1);
    });
    row(
      'Options',
      options.length
        ? options
            .map(function (o) {
              return o.name + ' (' + plural(o.values, 'value') + ')';
            })
            .join(', ')
        : 'No options (one variant)',
      true
    );
    row(
      'Variants',
      plural(p.variants, 'variant') + ' returned',
      p.variants > 0,
      p.variants === 0
        ? 'Without a variant, an agent has nothing it can add to a cart.'
        : store.variants > p.variants
          ? 'The catalog answers with the selected variant; your product has ' + store.variants + '.'
          : null
    );
    row(
      'Images',
      plural(p.images, 'image') + ' returned, ' + p.imagesWithAlt + ' with alt text',
      p.images > 0 && p.imagesWithAlt > 0,
      [
        store.images > p.images ? 'Your product has ' + store.images + ' images; the catalog returns the selected variant’s.' : null,
        p.images > 0 && p.imagesWithAlt === 0 ? 'Without alt text, an agent cannot tell what the photo shows.' : null,
      ]
        .filter(Boolean)
        .join(' ') || null
    );
    var barcodeNote = null;
    if (p.variantsWithBarcode === 0 && store.barcodesValid > 0) {
      barcodeNote =
        'Your store has valid barcodes on ' +
        store.barcodesValid +
        ' of ' +
        plural(store.variants, 'variant') +
        ' of this product in Shopify, ' +
        (gtinOnPage ? 'but none come back in this catalog.' : 'but they are not printed on your product pages or returned here, so agents never see them.');
    } else if (p.variantsWithBarcode === 0 && store.variantsWithBarcode > 0) {
      barcodeNote = 'The barcode field on this product holds a code that is not a valid GTIN (UPC, EAN or ISBN).';
    }
    row('Barcode (GTIN)', p.variantsWithBarcode > 0 ? 'Returned on ' + plural(p.variantsWithBarcode, 'variant') : 'None returned', p.variantsWithBarcode > 0, barcodeNote);
    row(
      'Specs (material, size, fit and so on)',
      p.specs ? 'Returned' : 'None returned',
      p.specs,
      p.specs ? null : 'No product metafields came back for this product.'
    );

    return el('div', { class: 'dfy-ucp' }, [
      el('h3', { text: 'What an AI agent gets from your store’s UCP catalog' }),
      el('p', {
        class: 'dfy-note',
        text:
          'This is the live answer from ' +
          storeHost +
          '/api/ucp/mcp, the catalog Shopify serves to AI shopping agents, for ' +
          (p.url ? p.url.replace(/^https?:\/\//, '') : 'one of your products') +
          '.',
      }),
      el('dl', {}, rows),
    ]);
  }

  function renderResult(target, form, result) {
    if (result.outcome !== 'scanned') return renderOutcome(target, form, result);
    var failing = result.checks.filter(function (c) {
      return !c.pass;
    }).length;
    var headline =
      failing === 0
        ? 'Your product pages pass all four checks'
        : 'AI shoppers miss ' + failing + ' of 4 things on your product pages';

    var checks = el(
      'ul',
      { class: 'dfy-result__checks' },
      result.checks.map(function (c) {
        return el('li', { class: 'dfy-result__check', 'data-pass': String(c.pass) }, [
          el('span', { class: 'dfy-icon', 'aria-hidden': 'true', text: c.pass ? '✓' : '✕' }),
          el('div', {}, [
            el('b', { text: (c.pass ? 'Yes: ' : 'No: ') + c.label }),
            el('small', { text: 'In our 2026 study, ' + c.study + '.' }),
          ]),
        ]);
      })
    );

    var fields = el(
      'ul',
      { class: 'dfy-fields' },
      Object.keys(FIELD_LABELS).map(function (key) {
        var present = Boolean(result.fields && result.fields[key]);
        return el('li', {
          'data-present': String(present),
          text: (present ? '✓ ' : '✕ ') + FIELD_LABELS[key],
        });
      })
    );

    target.replaceChildren(
      el('div', { class: 'dfy-result', role: 'status', tabindex: '-1' }, [
        el('div', { class: 'dfy-result__head' }, [
          el('div', { class: 'dfy-grade', 'data-band': band(result.grade) }, [
            el('b', { text: String(result.grade) }),
            el('span', { text: 'out of 100' }),
          ]),
          el('div', {}, [
            el('div', { class: 'dfy-eyebrow', text: result.storeHost + ' · ' + result.pagesGraded + ' product pages read' }),
            el('h2', { style: 'margin-top:8px', text: headline }),
          ]),
        ]),
        checks,
        el('h3', { text: 'The nine product facts an AI agent looks for' }),
        fields,
        renderUcp(
          result.ucp,
          result.storeHost,
          result.checks.some(function (c) {
            return c.key === 'gtin' && c.pass;
          })
        ),
        form.dataset.installUrl ? el('div', { class: 'dfy-result__cta' }, [
          installLink(form, failing ? 'Fix these with Datify, free on Shopify' : 'Keep it that way with Datify, free on Shopify'),
          el('span', {
            class: 'dfy-note',
            text: 'Datify fills categories, specs and barcodes in your catalog and prints them for AI agents. No code.',
          }),
        ]) : null,
      ])
    );
    var card = target.querySelector('.dfy-result');
    if (card && card.focus) card.focus({ preventScroll: true });
  }

  function showError(form, code) {
    var box = form.parentElement.querySelector('[data-dfy-check-error]');
    if (box) box.textContent = code ? MESSAGES[code] || MESSAGES.network : '';
  }

  function resultTarget(form) {
    var id = form.dataset.resultTarget;
    return (id && document.getElementById(id)) || form.parentElement.querySelector('[data-dfy-check-result]');
  }

  function poll(api, id, started) {
    return new Promise(function (resolve, reject) {
      function tick() {
        fetch(api + '/' + encodeURIComponent(id), { headers: { Accept: 'application/json' } })
          .then(function (res) {
            return res.json().then(function (body) {
              return { ok: res.ok, body: body };
            });
          })
          .then(function (r) {
            if (!r.ok) return reject(new Error(r.body.error || 'network'));
            if (r.body.status === 'done') return resolve(r.body.result);
            if (r.body.status === 'failed') return resolve({ outcome: 'error' });
            if (Date.now() - started > MAX_WAIT_MS) return reject(new Error('timeout'));
            setTimeout(tick, POLL_MS);
          })
          .catch(function (err) {
            reject(err && err.message === 'timeout' ? err : new Error('network'));
          });
      }
      tick();
    });
  }

  function onSubmit(event) {
    event.preventDefault();
    var form = event.currentTarget;
    var input = form.querySelector('input[name="store"]');
    var button = form.querySelector('button[type="submit"]');
    var store = (input.value || '').trim();
    var target = resultTarget(form);
    showError(form, null);
    if (form.dataset.busy !== 'true') target.replaceChildren();
    if (!store) {
      showError(form, 'invalid_store');
      input.focus();
      return;
    }
    if (form.dataset.busy === 'true') return;
    form.dataset.busy = 'true';
    button.disabled = true;
    var api = form.dataset.api.replace(/\/$/, '') + '/public/store-check';
    var host = store.replace(/^https?:\/\//i, '').split('/')[0];
    renderProgress(target, host);
    if (target.scrollIntoView) target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    track('datify_store_check_start', { page: form.dataset.page || '' });

    fetch(api, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ store: store, page: window.location.href, referrer: document.referrer || undefined, utm: utm() }),
    })
      .then(function (res) {
        return res.json().then(function (body) {
          if (!res.ok) throw new Error(body.error || 'network');
          return body;
        });
      })
      .then(function (body) {
        return poll(api, body.id, Date.now());
      })
      .then(function (result) {
        renderResult(target, form, result);
        track('datify_store_check_done', { outcome: result.outcome, grade: result.grade });
      })
      .catch(function (err) {
        target.replaceChildren();
        showError(form, err.message);
      })
      .finally(function () {
        form.dataset.busy = 'false';
        button.disabled = false;
      });
  }

  function init() {
    document.querySelectorAll('form[data-dfy-check]').forEach(function (form) {
      if (form.dataset.bound) return;
      form.dataset.bound = 'true';
      form.addEventListener('submit', onSubmit);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
